var _style, _defs, _text;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 806.9 293.48",
    style: {
      enableBackground: "new 0 0 806.9 293.48"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{clip-path:url(#SVGID_00000111170811314664375880000006492247966734663072_);fill:#878C8F;}\r\n\t.st1{clip-path:url(#SVGID_00000111170811314664375880000006492247966734663072_);fill:#00507D;}\r\n\t.st2{fill:#878C8F;}\r\n\t.st3{font-family:'MyriadPro-Regular';}\r\n\t.st4{font-size:87.7206px;}\r\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: -83.99,
    y: -302.98,
    width: 900,
    height: 900
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000083083227264610695870000012045577570311403193_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000083083227264610695870000012045577570311403193_)",
      fill: "#878C8F"
    },
    d: "M246.93,50.54h38.48 c29.38,0,35.45,25.01,35.45,41.52c0,18.7-7.4,45.64-36.17,45.64h-37.75V50.54z M264.77,122.64h17.72 c14.81,0,19.79-14.93,19.79-29.26c0-25.74-12.26-27.8-20.03-27.8h-17.48V122.64z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000083083227264610695870000012045577570311403193_)",
      fill: "#878C8F"
    },
    d: "M385.56,123.37 c0,7.65,1.7,11.05,3.76,11.77v2.55h-18.33c-0.97-3.04-1.21-5.71-1.58-9.35c-3.89,4.01-9.35,9.35-20.88,9.35 c-9.71,0-19.67-5.46-19.67-18.82c0-12.62,8.01-19.06,18.82-20.64l15.3-2.31c2.67-0.36,5.95-1.46,5.95-5.1 c0-7.16-6.8-7.53-11.17-7.53c-8.5,0-9.95,5.22-10.44,8.98h-16.39c1.94-19.79,15.66-22.58,28.89-22.58c9.1,0,25.73,2.79,25.73,18.7 V123.37z M368.92,104.56c-1.7,1.33-4.49,2.43-11.53,3.52c-6.31,1.09-11.53,2.67-11.53,9.71c0,5.95,4.61,7.77,7.89,7.77 c7.53,0,15.17-4.86,15.17-12.75V104.56z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000083083227264610695870000012045577570311403193_)",
      fill: "#878C8F"
    },
    d: "M459.11,137.65h-16.99 V96.79c0-4.73-0.24-12.75-11.05-12.75c-7.53,0-13.35,5.1-13.35,14.93v38.68h-17V69.72h16.27v11.17h0.24 c2.31-3.88,7.16-11.17,19.42-11.17c12.62,0,22.46,7.4,22.46,21.61V137.65z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 475.38,
    y: 50.54,
    style: {
      clipPath: "url(#SVGID_00000083083227264610695870000012045577570311403193_)",
      fill: "#878C8F"
    },
    width: 17,
    height: 15.78
  }), /*#__PURE__*/React.createElement("rect", {
    x: 475.38,
    y: 73.12,
    style: {
      clipPath: "url(#SVGID_00000083083227264610695870000012045577570311403193_)",
      fill: "#878C8F"
    },
    width: 17,
    height: 64.58
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000083083227264610695870000012045577570311403193_)",
      fill: "#878C8F"
    },
    d: "M564.11,117.06 c-4.49,15.54-17.36,20.64-28.41,20.64c-18.21,0-32.17-8.74-32.17-35.33c0-7.77,2.67-32.65,30.96-32.65 c12.75,0,30.35,6.07,30.35,35.57v3.03h-44.31c0.49,4.85,1.46,15.78,15.17,15.78c4.74,0,9.59-2.43,10.93-7.04H564.11z M547.36,97.27 c-0.97-10.44-7.65-13.6-13.11-13.6c-8.01,0-12.26,5.1-13.23,13.6H547.36z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 576.62,
    y: 50.54,
    style: {
      clipPath: "url(#SVGID_00000083083227264610695870000012045577570311403193_)",
      fill: "#878C8F"
    },
    width: 16.99,
    height: 87.16
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000083083227264610695870000012045577570311403193_)",
      fill: "#878C8F"
    },
    d: "M263.53,217.43 c0.11,4.61,2.42,13.37,17.52,13.37c8.19,0,17.29-1.96,17.29-10.72c0-6.46-6.23-8.19-14.99-10.26l-8.88-2.08 c-13.37-3.11-26.29-6.11-26.29-24.33c0-9.22,4.96-25.48,31.82-25.48c25.36,0,32.17,16.6,32.28,26.75h-16.6 c-0.46-3.69-1.85-12.45-16.95-12.45c-6.57,0-14.41,2.42-14.41,9.92c0,6.46,5.3,7.84,8.76,8.65l20.18,4.96 c11.3,2.77,21.67,7.38,21.67,22.25c0,24.9-25.36,27.09-32.63,27.09c-30.21,0-35.39-17.41-35.39-27.67H263.53z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000083083227264610695870000012045577570311403193_)",
      fill: "#878C8F"
    },
    d: "M343.27,177.12h10.56 v12.14h-10.56v37.75c0,3.76,0.12,5.22,7.04,5.22c1.09,0,2.31-0.12,3.52-0.24v12.87c-2.67,0.12-5.34,0.24-8.01,0.24h-2.19 c-14.69,0-17.36-5.58-17.36-13.96v-41.88h-8.74v-12.14h8.74v-19.18h17V177.12z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000083083227264610695870000012045577570311403193_)",
      fill: "#878C8F"
    },
    d: "M414.55,230.78 c0,7.65,1.7,11.05,3.76,11.78v2.55h-18.33c-0.97-3.04-1.21-5.71-1.58-9.35c-3.89,4.01-9.35,9.35-20.88,9.35 c-9.71,0-19.67-5.46-19.67-18.82c0-12.62,8.01-19.06,18.82-20.64l15.3-2.31c2.67-0.36,5.95-1.46,5.95-5.1 c0-7.16-6.8-7.53-11.17-7.53c-8.5,0-9.95,5.22-10.44,8.98h-16.39c1.94-19.79,15.66-22.58,28.89-22.58c9.1,0,25.73,2.79,25.73,18.69 V230.78z M397.92,211.96c-1.7,1.34-4.49,2.43-11.53,3.52c-6.31,1.09-11.53,2.67-11.53,9.71c0,5.95,4.61,7.77,7.89,7.77 c7.53,0,15.17-4.86,15.17-12.75V211.96z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000083083227264610695870000012045577570311403193_)",
      fill: "#878C8F"
    },
    d: "M482.2,245.1h-17 v-40.91c0-4.73-0.24-12.75-11.05-12.75c-7.53,0-13.35,5.1-13.35,14.93v38.72h-17v-67.98h16.27v11.17h0.24 c2.31-3.88,7.16-11.17,19.42-11.17c12.62,0,22.46,7.41,22.46,21.61V245.1z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000083083227264610695870000012045577570311403193_)",
      fill: "#878C8F"
    },
    d: "M552.25,245.1h-16.63 v-9.83h-0.24c-4.13,7.28-11.65,9.83-18.69,9.83c-19.18,0-27.19-17-27.19-34.72c0-22.34,12.62-33.26,26.83-33.26 c10.92,0,16.02,5.95,18.69,10.08h0.24v-29.26h17V245.1z M520.94,231.14c10.8,0,15.05-8.98,15.05-18.57 c0-10.32-2.91-20.76-14.57-20.76c-10.8,0-14.45,9.59-14.45,19.79C506.98,219.24,510.01,231.14,520.94,231.14"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000083083227264610695870000012045577570311403193_)",
      fill: "#878C8F"
    },
    d: "M617.32,230.78 c0,7.65,1.7,11.05,3.76,11.78v2.55h-18.33c-0.97-3.04-1.21-5.71-1.58-9.35c-3.88,4.01-9.35,9.35-20.88,9.35 c-9.71,0-19.67-5.46-19.67-18.82c0-12.62,8.01-19.06,18.82-20.64l15.3-2.31c2.67-0.36,5.95-1.46,5.95-5.1 c0-7.16-6.8-7.53-11.17-7.53c-8.5,0-9.95,5.22-10.44,8.98h-16.39c1.94-19.79,15.66-22.58,28.89-22.58c9.1,0,25.74,2.79,25.74,18.69 V230.78z M600.69,211.96c-1.7,1.34-4.49,2.43-11.53,3.52c-6.31,1.09-11.53,2.67-11.53,9.71c0,5.95,4.61,7.77,7.89,7.77 c7.53,0,15.17-4.86,15.17-12.75V211.96z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000083083227264610695870000012045577570311403193_)",
      fill: "#878C8F"
    },
    d: "M629.34,177.12h16.27 v12.87h0.24c3.52-6.56,7.41-12.87,17.72-12.87c1.09,0,2.18,0.12,3.28,0.24v17.24c-1.46-0.24-3.28-0.24-4.85-0.24 c-13.23,0-15.66,8.25-15.66,15.42v35.33h-17V177.12z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000083083227264610695870000012045577570311403193_)",
      fill: "#878C8F"
    },
    d: "M732.02,245.1h-16.63 v-9.83h-0.24c-4.13,7.28-11.65,9.83-18.69,9.83c-19.18,0-27.19-17-27.19-34.72c0-22.34,12.62-33.26,26.83-33.26 c10.92,0,16.02,5.95,18.7,10.08h0.24v-29.26h17V245.1z M700.7,231.14c10.8,0,15.05-8.98,15.05-18.57 c0-10.32-2.91-20.76-14.57-20.76c-10.8,0-14.45,9.59-14.45,19.79C686.74,219.24,689.78,231.14,700.7,231.14"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000083083227264610695870000012045577570311403193_)",
      fill: "#00507D"
    },
    d: "M255.61,293.67 c-3.39,0-5.83-0.79-7.98-2.98l2.28-2.25c1.65,1.65,3.45,2.16,5.76,2.16c2.95,0,4.66-1.27,4.66-3.45c0-0.98-0.29-1.81-0.89-2.34 c-0.57-0.54-1.14-0.76-2.47-0.95l-2.66-0.38c-1.84-0.25-3.29-0.88-4.28-1.8c-1.11-1.04-1.65-2.47-1.65-4.31 c0-3.93,2.85-6.62,7.54-6.62c2.98,0,5.07,0.76,7,2.57l-2.19,2.16c-1.39-1.33-3.01-1.74-4.91-1.74c-2.66,0-4.12,1.52-4.12,3.52 c0,0.82,0.25,1.55,0.85,2.09c0.57,0.51,1.49,0.89,2.53,1.04l2.57,0.38c2.09,0.32,3.26,0.82,4.21,1.68 c1.24,1.08,1.84,2.69,1.84,4.63C263.73,291.2,260.34,293.67,255.61,293.67"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000083083227264610695870000012045577570311403193_)",
      fill: "#00507D"
    },
    d: "M286.62,291.26 c-1.55,1.55-3.55,2.41-5.96,2.41c-2.41,0-4.37-0.86-5.92-2.41c-2.22-2.22-2.19-4.72-2.19-9.06c0-4.34-0.03-6.85,2.19-9.06 c1.55-1.55,3.52-2.41,5.92-2.41c2.41,0,4.41,0.86,5.96,2.41c2.22,2.22,2.15,4.72,2.15,9.06 C288.78,286.54,288.84,289.04,286.62,291.26 M284.03,275.2c-0.79-0.86-2.03-1.4-3.36-1.4c-1.33,0-2.57,0.54-3.36,1.4 c-1.11,1.21-1.33,2.47-1.33,7c0,4.53,0.22,5.79,1.33,7c0.79,0.85,2.03,1.4,3.36,1.4c1.33,0,2.57-0.54,3.36-1.4 c1.11-1.2,1.33-2.47,1.33-7C285.36,277.67,285.13,276.41,284.03,275.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000083083227264610695870000012045577570311403193_)",
      fill: "#00507D"
    },
    points: "302.33,273.99  302.33,280.87 311.71,280.87 311.71,283.94 302.33,283.94 302.33,293.48 298.91,293.48 298.91,270.92 313.33,270.92 313.33,273.99  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000083083227264610695870000012045577570311403193_)",
      fill: "#00507D"
    },
    points: "330.14,273.99  330.14,293.48 326.72,293.48 326.72,273.99 320.51,273.99 320.51,270.92 336.35,270.92 336.35,273.99  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000083083227264610695870000012045577570311403193_)",
      fill: "#00507D"
    },
    points: "363.71,293.48  360.74,293.48 356.14,277.67 351.58,293.48 348.6,293.48 342.71,270.92 346.32,270.92 350.25,287.05 354.78,270.92 357.54,270.92  362.07,287.05 365.99,270.92 369.61,270.92  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000083083227264610695870000012045577570311403193_)",
      fill: "#00507D"
    },
    d: "M390.47,293.48 l-1.55-4.53h-8.9l-1.55,4.53h-3.64l8.27-22.56h2.75l8.27,22.56H390.47z M384.55,276.02l-3.51,10.01h6.94L384.55,276.02z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000083083227264610695870000012045577570311403193_)",
      fill: "#00507D"
    },
    d: "M414.83,293.48 l-4.75-9.51h-4.28v9.51h-3.42v-22.56h8.74c4.28,0,7,2.76,7,6.59c0,3.23-1.96,5.29-4.5,5.99l5.19,9.98H414.83z M410.87,273.99h-5.07 v7.07h5.07c2.28,0,3.83-1.3,3.83-3.52C414.7,275.33,413.15,273.99,410.87,273.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000083083227264610695870000012045577570311403193_)",
      fill: "#00507D"
    },
    points: "428.19,293.48  428.19,270.92 442.61,270.92 442.61,273.99 431.61,273.99 431.61,280.58 440.99,280.58 440.99,283.63 431.61,283.63 431.61,290.41  442.61,290.41 442.61,293.48  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000083083227264610695870000012045577570311403193_)",
      fill: "#00507D"
    },
    d: "M478.77,291.36 c-1.43,1.42-3.49,2.12-5.83,2.12h-7.92v-22.56h7.92c2.34,0,4.4,0.7,5.83,2.12c2.44,2.44,2.28,5.74,2.28,9 C481.06,285.31,481.21,288.92,478.77,291.36 M476.43,275.52c-0.95-1.04-2.22-1.52-3.84-1.52h-4.15v16.41h4.15 c1.62,0,2.88-0.48,3.84-1.52c1.17-1.3,1.2-3.74,1.2-6.84C477.63,278.94,477.6,276.82,476.43,275.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000083083227264610695870000012045577570311403193_)",
      fill: "#00507D"
    },
    points: "491.19,293.48  491.19,270.92 505.6,270.92 505.6,273.99 494.6,273.99 494.6,280.58 503.98,280.58 503.98,283.63 494.6,283.63 494.6,290.41  505.6,290.41 505.6,293.48  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000083083227264610695870000012045577570311403193_)",
      fill: "#00507D"
    },
    points: "522.64,293.48  519.98,293.48 512.57,270.92 516.11,270.92 521.31,287.33 526.5,270.92 530.12,270.92  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000083083227264610695870000012045577570311403193_)",
      fill: "#00507D"
    },
    points: "538.28,293.48  538.28,270.92 552.7,270.92 552.7,273.99 541.7,273.99 541.7,280.58 551.08,280.58 551.08,283.63 541.7,283.63 541.7,290.41  552.7,290.41 552.7,293.48  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000083083227264610695870000012045577570311403193_)",
      fill: "#00507D"
    },
    points: "562.45,293.48  562.45,270.92 565.87,270.92 565.87,290.41 576.74,290.41 576.74,293.48  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000083083227264610695870000012045577570311403193_)",
      fill: "#00507D"
    },
    d: "M597.98,291.26 c-1.55,1.55-3.55,2.41-5.96,2.41c-2.41,0-4.37-0.86-5.92-2.41c-2.22-2.22-2.19-4.72-2.19-9.06c0-4.34-0.03-6.85,2.19-9.06 c1.55-1.55,3.52-2.41,5.92-2.41c2.41,0,4.41,0.86,5.96,2.41c2.22,2.22,2.15,4.72,2.15,9.06 C600.14,286.54,600.2,289.04,597.98,291.26 M595.39,275.2c-0.79-0.86-2.03-1.4-3.36-1.4c-1.33,0-2.57,0.54-3.36,1.4 c-1.11,1.21-1.33,2.47-1.33,7c0,4.53,0.22,5.79,1.33,7c0.79,0.85,2.03,1.4,3.36,1.4c1.33,0,2.57-0.54,3.36-1.4 c1.11-1.2,1.33-2.47,1.33-7C596.72,277.67,596.5,276.41,595.39,275.2"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000083083227264610695870000012045577570311403193_)",
      fill: "#00507D"
    },
    d: "M618.82,284.61h-5.13 v8.87h-3.42v-22.56h8.55c4.41,0,7.22,2.91,7.22,6.84C626.05,281.7,623.23,284.61,618.82,284.61 M618.64,273.99h-4.94v7.51h4.94 c2.38,0,3.99-1.36,3.99-3.74C622.63,275.39,621.01,273.99,618.64,273.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000083083227264610695870000012045577570311403193_)",
      fill: "#00507D"
    },
    points: "651.74,293.48  651.74,278.4 646.54,289.39 644,289.39 638.68,278.4 638.68,293.48 635.26,293.48 635.26,270.92 638.68,270.92 645.27,284.96  651.74,270.92 655.16,270.92 655.16,293.48  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000083083227264610695870000012045577570311403193_)",
      fill: "#00507D"
    },
    points: "666.08,293.48  666.08,270.92 680.49,270.92 680.49,273.99 669.5,273.99 669.5,280.58 678.88,280.58 678.88,283.63 669.5,283.63 669.5,290.41  680.49,290.41 680.49,293.48  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000083083227264610695870000012045577570311403193_)",
      fill: "#00507D"
    },
    points: "704.09,293.48  693.66,277.61 693.66,293.48 690.24,293.48 690.24,270.92 693.38,270.92 703.8,286.76 703.8,270.92 707.23,270.92 707.23,293.48  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      clipPath: "url(#SVGID_00000083083227264610695870000012045577570311403193_)",
      fill: "#00507D"
    },
    points: "725.81,273.99  725.81,293.48 722.39,293.48 722.39,273.99 716.18,273.99 716.18,270.92 732.02,270.92 732.02,273.99  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000083083227264610695870000012045577570311403193_)",
      fill: "#00507D"
    },
    d: "M141.04,0.38H10.16 C4.55,0.38,0,4.93,0,10.54v91.26c0,9.64,5.2,18.53,13.61,23.25l34.34,19.29c1.13,0.63,2.52-0.18,2.52-1.47v-82.8 c0-5.1,4.13-9.23,9.23-9.23h88.95c5.1,0,9.23,4.13,9.23,9.23v57.76v1.43c0,1.28,0.69,2.45,1.8,3.08l43.76,24.58 c2.19,1.23,4.9-0.35,4.9-2.87v-26.22V67.68C208.34,30.51,178.21,0.38,141.04,0.38"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000083083227264610695870000012045577570311403193_)",
      fill: "#00507D"
    },
    d: "M194.73,168.75 l-36.85-20.7v0.02l-40.32-22.65c-12.11-6.8-27.82-3.17-34.85,8.82c-7.16,12.21-2.88,27.86,9.4,34.76l59.66,33.52 c3.77,2.12,6.11,6.11,6.11,10.44v21.03c0,5.1-4.13,9.23-9.23,9.23H59.69c-5.1,0-9.23-4.13-9.23-9.23v-59.7 c0-1.11-0.6-2.14-1.57-2.69L5.35,147.13C2.95,145.79,0,147.52,0,150.26v133.24c0,5.61,4.55,10.16,10.16,10.16h130.87 c37.17,0,67.3-30.13,67.3-67.3V192C208.34,182.36,203.14,173.47,194.73,168.75"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000083083227264610695870000012045577570311403193_)",
      fill: "#00507D"
    },
    d: "M112.13,226.75 c0-4.4-3.57-7.97-7.97-7.97c-4.4,0-7.97,3.57-7.97,7.97s3.57,7.97,7.97,7.97C108.57,234.72,112.13,231.15,112.13,226.75"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000083083227264610695870000012045577570311403193_)",
      fill: "#00507D"
    },
    d: "M112.41,66.14 c1.41,0,2.56-1.15,2.56-2.56v-0.34c0-1.41-1.15-2.56-2.56-2.56H95.93c-1.41,0-2.56,1.14-2.56,2.56v0.34c0,1.41,1.14,2.56,2.56,2.56 H112.41z"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 741.0523 276.0321)",
    className: "st2 st3 st4"
  }, "\xAE")));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.44e7672f2c0f9e01334fec18203015b5.svg";
export { ForwardRef as ReactComponent };